import superagentPromise from "superagent-promise";
import _superagent, { get } from "superagent";

const superagent = superagentPromise(_superagent, global.Promise);
// const API_ROOT = "https://dev.shadowzapp.com:3001/";
// const LIVE_BUCKET = 'https://shadowzapp.com/'
// const STAGING_BUCKET = 'https://dev.shadowzapp.com/'


const IS_STAGING = (window.origin.includes('dev') || window.origin.includes('localhost'));

const LIVE_BUCKET = 'https://shadowzapp.com/'

//const LIVE_BUCKET = "https://api.shadowzapp.com/"

const STAGING_BUCKET = 'https://dev.shadowzapp.com/'
// const BUCKET_LINK = IS_STAGING ? STAGING_BUCKET : LIVE_BUCKET
const BUCKET_LINK =  LIVE_BUCKET

//const LIVE_API_ROOT = "https://shadowzapp.com:3000/"; //live
const LIVE_API_ROOT = "https://api.shadowzapp.com/"; //live

const STAGING_API_ROOT = "https://dev.shadowzapp.com:3001/"; //staging
// const API_ROOT = IS_STAGING ? STAGING_API_ROOT : LIVE_API_ROOT
const API_ROOT = LIVE_API_ROOT

// const API_ROOT = "https://dev.shadowzapp.com:3001/";
const STORAGE_BASE_URL = 'https://shadowzapp.sgp1.digitaloceanspaces.com/'
const API_ROOT_IMAGEUPLOAD = `https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/medium/`;
const API_FILE_ROOT_SMALL = `${STORAGE_BASE_URL}images/small/`;
const API_FILE_ROOT_MEDIUM = `${STORAGE_BASE_URL}shadowzapp/images/medium/`;
const API_FILE_ROOT_ORIGINAL = `${STORAGE_BASE_URL}shadowzapp/original/`;
const API_FILE_ROOT_VIDEO = `${STORAGE_BASE_URL}video/`;

const encode = encodeURIComponent;
const responseBody = (res) => res.body;

let token = null;
const tokenPlugin = (req) => {
  if (token) {
    req.set("token", `${token}`);
  }
};

const requests = {
  del: (url) =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: (url) =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  patch: (url, body) =>
    superagent
      .patch(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
};

const Auth = {
  login: (info) => requests.post("Admin/login", info),
  signup: (info) => requests.post("signup", info),
  forgotPassword: (info) => requests.post("forgot-password", info),
  checkOtp: (info) => requests.post("check-email-otp", info),
  resetPassword: (info) => requests.post("User/reset_password", info),
  changePassword: (info) => requests.put("admin/change-password", info),
};

const Suscribe = {
  sendEmail: (info) => requests.post(`User/subscriber`,info),
};
const Policies = {
   all: (type) =>
    requests.get(
      `Admin/contents?language=ENGLISH${type ? `&type=${type}` : ""}`
    ),
};
export default {
  Auth,
  Suscribe,
  Policies,
  // Nfts,
  API_ROOT,
  API_FILE_ROOT_SMALL,
  API_ROOT_IMAGEUPLOAD,
  API_FILE_ROOT_MEDIUM,
  API_FILE_ROOT_ORIGINAL,
  API_FILE_ROOT_VIDEO,
  setToken: (_token) => {
    token = _token;
  },
};
